<template>
    <div>
        <!-- the avatar and name and rate section -->
        <div class="content-FW-popup" style="position: relative; padding: 15px 20px 25px 21px;">
            <!-- the avatar -->
            <a :href="contractorUrl(contractorData.contractor_id)" style="position: absolute; width: 60px; height: 60px; border-radius: 50%;"></a>
            <img class="ghassan_avatar" :src="contractorData.avatar" width="40" height="40" style="align:center; margin-top: 3px">
            <!-- name and rate -->
            <div class="text" style="text-align: left; margin-left: 5px">
                <h3 style="margin-bottom: 1px">
                    <strong>
                        <a :href="contractorUrl(contractorData.contractor_id)" style="color: #2E4051; font-weight: 800; font-size: 14px;" target="_blank">{{ contractorData.display_name }}</a>
                    </strong>
                </h3>
                <div class="_color" style="font-weight: bold; margin-bottom: unset; font-size: 12px; padding-top: 3px; padding-bottom: 3px; line-height: initial;">
                    {{ contractorData.business_name }}
                </div>
                <div id="stars" class="stars _color" style="line-height: initial;">
                    <span v-for="(star, index) in contractorData.rate" :key="index" class="fa" :class="star" style="font-size: x-small;"></span>
                </div>
            </div>
            <!-- the close button -->
            <div>
                <a href="javascript:" @click="closeSummaryPopup" style="float: right" class="btn btn-close close DontShowCloseButton2Times">
                    <span>×</span>
                </a>
            </div>
        </div>

        <!-- information section -->
        <div class="row" style="text-align: left; padding: 0px 20px 15px 40px">
            <div class="col-xs-12 summary-rows _color line_iniial_rows">Employed since: {{ contractorData.since }}</div>
            <div class="col-xs-12 summary-rows _color line_iniial_rows">Completed bookings: {{ contractorData.complete_services }}</div>
            <div class="col-xs-12 summary-rows _color line_iniial_rows">Customer satisfaction: {{ contractorData.Customer_satisfaction }}%</div>
            <div class="col-xs-12 summary-rows _color line_iniial_rows">Home: {{ contractorData.home }}</div>
        </div>

        <!-- bio section -->
        <div v-if="contractorData.bio" style="text-align: left!important; padding: 0px 25px 20px 25px;">
            <div style="color: #6b7883; font-size: 13px; font-weight: 600; overflow-wrap: break-word; line-height: initial;">{{ contractorData.bio }}</div>
        </div>

        <!-- labels section -->
        <div v-if="contractorData.labels && contractorData.labels.length > 0" class="details_info_l" style="text-align: left; padding-left: 24px; padding-right: 24px; font-size:12px; margin-bottom: 2px; padding-bottom: 20px;">
            <common-labels
                           :key="contractorData.contractor_id"
                           :unique-id="contractorData.contractor_id"
                           :labels="contractorData.vue_labels"
                           action-name="contractorSelectLabel"
                           list-container="span"
                           :base-url = "contractorData.base_url"
            >
            </common-labels>
        </div>

        <!-- send mail and call section -->
        <div v-if="(contractorData.credentials|| {}).hasSendEmailCredential" class="margin_btm_less pad-l-24-map" style="line-height: initial; padding-bottom: 20px; position: relative; width: fit-content; padding-left: 24px;">
            <a style="padding-right: 14px !important;" href="#" data-toggle="modal" data-target="#popupi" @click="sendMail">
            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 50 50">
                <g id="Group_14266" data-name="Group 14266" transform="translate(-957 -483)">
                    <g id="Group_13612" data-name="Group 13612" transform="translate(-6083 542)">
                        <rect id="Rectangle_7936" data-name="Rectangle 7936" width="50" height="50" rx="4"
                              transform="translate(7040 -59)" fill="#03a9f4"/>
                    </g>
                    <g id="baseline-email-24px" transform="translate(970 496)">
                        <path id="Path_7889" data-name="Path 7889"
                              d="M20,4H4A2,2,0,0,0,2.01,6L2,18a2.006,2.006,0,0,0,2,2H20a2.006,2.006,0,0,0,2-2V6A2.006,2.006,0,0,0,20,4Zm0,4-8,5L4,8V6l8,5,8-5Z"
                              fill="#fff"/>
                        <path id="Path_7890" data-name="Path 7890" d="M0,0H24V24H0Z" fill="none"/>
                    </g>
                </g>
            </svg>
            </a>

            <a style="padding-right: 14px !important;" class="details_info_opt" data-numbers="" @click="callFieldWorker">
            <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 50 50">
                <g id="Group_14267" data-name="Group 14267" transform="translate(-1052 -483)">
                    <g id="Group_14119" data-name="Group 14119" transform="translate(-5988 542)">
                        <rect id="Rectangle_7936" data-name="Rectangle 7936" width="50" height="50" rx="4" transform="translate(7040 -59)" fill="#03a9f4"/>
                    </g>
                    <g id="baseline-phone-24px" transform="translate(1065 496)">
                        <path id="Path_7891" data-name="Path 7891" d="M0,0H24V24H0Z" fill="none"/>
                        <path id="Path_7892" data-name="Path 7892" d="M6.62,10.79a15.149,15.149,0,0,0,6.59,6.59l2.2-2.2a.994.994,0,0,1,1.02-.24,11.407,11.407,0,0,0,3.57.57,1,1,0,0,1,1,1V20a1,1,0,0,1-1,1A17,17,0,0,1,3,4,1,1,0,0,1,4,3H7.5a1,1,0,0,1,1,1,11.36,11.36,0,0,0,.57,3.57,1,1,0,0,1-.25,1.02Z" fill="#fff"/>
                    </g>
                </g>
            </svg>
            </a>

            <a href="javaScript:void(0)" data-toggle="modal" data-target="#popupi" @click="fieldworkerDiscuss"
               style="padding-right: 14px !important;">
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 50 50">
                    <g id="Group_14274" data-name="Group 14274" transform="translate(-957 -483)">
                        <g id="Group_13612" data-name="Group 13612" transform="translate(-6083 542)">
                            <rect id="Rectangle_7936" data-name="Rectangle 7936" width="50" height="50" rx="4" transform="translate(7040 -59)" fill="#03a9f4"/>
                        </g>
                        <g id="baseline-chat_bubble-24px" transform="translate(970 496)">
                            <path id="Path_7906" data-name="Path 7906" d="M20,2H4A2.006,2.006,0,0,0,2,4V22l4-4H20a2.006,2.006,0,0,0,2-2V4A2.006,2.006,0,0,0,20,2Z" fill="#fff"/>
                            <path id="Path_7907" data-name="Path 7907" d="M0,0H24V24H0Z" fill="none"/>
                        </g>
                        <text id="Chat" transform="translate(974 526)" fill="#fff" font-size="8" font-family="Roboto-Bold, Roboto" font-weight="700"><tspan x="0" y="0">Chat</tspan></text>
                    </g>
                </svg>
            </a>

            <a href="javaScript:void(0)" data-toggle="modal" data-target="#popupi" @click="sendSms">
                <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 50 50">
                    <g id="Group_14275" data-name="Group 14275" transform="translate(-957 -483)">
                        <g id="Group_13612" data-name="Group 13612" transform="translate(-6083 542)">
                            <rect id="Rectangle_7936" data-name="Rectangle 7936" width="50" height="50" rx="4" transform="translate(7040 -59)" fill="#03a9f4"/>
                        </g>
                        <text id="SMS" transform="translate(974 526)" fill="#fff" font-size="8" font-family="Roboto-Bold, Roboto" font-weight="700"><tspan x="0" y="0">SMS</tspan></text>
                        <g id="baseline-chat_bubble-24px" transform="translate(970 496)">
                            <path id="Path_7906" data-name="Path 7906" d="M20,2H4A2.006,2.006,0,0,0,2,4V22l4-4H20a2.006,2.006,0,0,0,2-2V4A2.006,2.006,0,0,0,20,2Z" fill="#fff"/>
                            <path id="Path_7907" data-name="Path 7907" d="M0,0H24V24H0Z" fill="none"/>
                        </g>
                    </g>
                </svg>
            </a>

        </div>

        <!-- calendar and profile section URLs -->
        <div class="row" style="border-top: 1px solid #e9e9e9; padding: 0px 0px 0px 0px; margin: 0">
            <div class="col-xs-6" style="border-right: 1px solid #e9e9e9; padding-top: 10px; padding-bottom: 8px;">
                <a :href="calendarUrl(contractorData.contractor_id, contractorData.active)" style="color: #676a6c; text-align: center" target="_blank"><h5>View calendar</h5></a>
            </div>
            <div class="col-xs-6" style="padding-top: 10px; padding-bottom: 8px; padding-left: 26px;">
                <a :href="contractorUrl(contractorData.contractor_id)" style="color: #676a6c; text-align: center" target="_blank"><h5>View profile</h5></a>
            </div>
        </div>
    </div>
</template>

<script>
import {getContractorDataById} from "@/modules/common/api";

export default {
    name: 'ContractorInfo',
    props:{
      id:{
          required: true
      },
        itemType: {
            type: String,
            default: 'contractorprofile'
        },
        itemId: {
            default: null
        }
    },
    data() {
        return {
            contractorData: {
            },
        };
    },
    mounted() {
        this.fetchContractorData();
    },
    watch: {
      id: {
        handler: 'fetchContractorData',
        immediate: true
      }
    },
    methods: {
        fetchContractorData() {
            getContractorDataById(this.id).then(response => {
              this.contractorData = response.data;
            });
        },
        contractorUrl(contractorId) {
            // Generate URL for contractor info
            return `/settings/contractor-info/${contractorId}`;
        },
        calendarUrl(contractorId, isActive) {
            // Generate URL for calendar
            return `/calendar?fltr[contractor_ids][]=${contractorId}&active=${isActive}`;
        },
        closeSummaryPopup() {
            // Logic to close popup
        },
        sendMail(){
           const sendMailLink = `/get-canned-responses-form/Fieldworker/email/${this.itemType}/${this.itemId}/${this.id}`;
            window.popupi('Send Email',sendMailLink, 'getCannedResponsesForm');
        },
        callFieldWorker(){

            // Determine the first parameter based on conditions
            const firstParam = (this.contractorData.office_user_mobile_info_id && this.contractorData.isMobile) ? 'mobile' : 'choose';

            // Determine the second parameter based on conditions
            const secondParam = (this.contractorData.office_user_mobile_info_id && this.contractorData.isMobile) ? this.contractorData.mobileLink : null;

            // Construct the URL for the third parameter
            const thirdParam = `/adminTwilioNewCall/${this.itemId}/user/${this.itemType}/${this.id}`;

            // The fourth and fifth parameters seem straightforward
            const fourthParam = this.contractorData.display_name;
            const fifthParam = this.contractorData.ContractorNumbers;

            // Call the function with the determined parameters
            window.regularCallPopup(firstParam, secondParam, thirdParam, fourthParam, fifthParam);


        },
        fieldworkerDiscuss(){
                const discussionLink = `/settings/contractor-discussion/${this.id}?user_role=contractor`
            window.popupi('Fieldworker Discussion',discussionLink)
        },
        sendSms(){
          const sendSmsLink = `/get-canned-responses-form/contractor/sms/${this.itemType}/${this.itemId}/${this.id}`
            window.popupi('Send SMS',sendSmsLink,'getCannedResponsesForm')
        }
    },
};
</script>

<style scoped>
</style>
